<template>
  <WorkPackageSubPageModule
    :workpackage="workpackage"
    :isMobile="isMobile"
    :location="location"
    :loading="loading"
    :background_color="workpackage_bg_hex"
    :foreground_color="workpackage_fg_hex"
    :header_icon="$store.state.Ultra.step_icons[step_type.toLowerCase()]"
    :header_text_short="$t(`WorkpackageRework.Steps.Types.${step_type}`)"
    :header_text_long="$t(`WorkpackageRework.Steps.Types.${step_type}`) + '.' + $t(`WorkpackageRework.Steps.steps`)"
    @headerBack="$router.push({name: `${location}WorkPackageInfo`, params: { nav_back: $route.params.nav_back} })"
  >
    <template #header-rightside>
      <TTooltip v-if="isEditMode" :value="getProjectTooltip({project_id: project_id, action: 'Add', entity: `${step_type} Steps`, twp: workpackage.id})">
        <v-btn
          :disabled="!hasProjectPermissionForTWP({project_id: project_id, action: 'Add', entity: `${step_type} Steps`, twp: workpackage.id})"
          icon
          :color="workpackage_fg_hex"
          @click="$router.push({
            name: `${location}WorkPackage${step_type}StepsDetails`,
            params: {
              content_id: 'create',
              nav_back: $route.params.nav_back,
            }
          })"
        >
          <TIcon name="sign-plus"/>
        </v-btn>
      </TTooltip>
    </template>
    <template #header-slot>
      <div v-if="step_type === 'Work'" class="d-flex header-slot-total" :style="`color: ${transparent_color}`">
        <TIcon
          name="speedometer"
          :color="transparent_color"
          small
        />
        {{ calcAllWorkStepsTotal({workpackage, prefix}).value }} mh
      </div>
    </template>
    <template #body>
      <StepPageStepList
        :steps="steps"
        :step_type="step_type"
        :prefix="prefix"
        :backlog="backlog"
        :has_lines="true"
        :background_color="workpackage_bg_hex"
        :foreground_color="workpackage_fg_hex"
        :isEditMode="isEditMode"
        :wp="workpackage"
        @clickStepList="$router.push({
          name: `${location}WorkPackage${step_type}StepsDetails`,
          params: {
            content_id: $event,
            nav_back: $route.params.nav_back,
          }
          })"
        @clickStepDone="updateUObject({
          url: getStepUrl(step_type, $event.step_id),
          update: {
            [step_type === 'Material'?'status':'done']: $event.set_to
          }
          }),
          location === 'ProjectWallet'?
          updateStepCardStatus({
            project_id: project_id,
            step_id: $event.step_id,
            step_type: step_type.toLowerCase(),
            done: $event.set_to,
            offset: $event.step.offset,
            /* offset: step_card.offset,
            wallet_column: wallet_column, */
            }).then(() => {
              increaseUpdateKeyStepCard();
              })
            :''
          "
          @draggableEnd="
          $event.newIndex - $event.oldIndex !== 0?
          (
          backlog?
            updateUObjectPosition({
              url: getStepUrl(step_type, workpackage[`${histprefix}${prefix}${step_type.toLowerCase()}steps`][$event.oldIndex]),
              update: {
                position: $event.newIndex - $event.oldIndex
              }
            })
          :
          requestSnackbarUpdatePosition({
            url: getStepUrl(step_type, workpackage[`${histprefix}t${step_type.toLowerCase()}steps`][$event.oldIndex]),
            update: {
              position: $event.newIndex - $event.oldIndex
            },
            selector: 'parent',
            limit_selector: true
          }).then((payload) => {
            updateUObjectPosition(payload)
          })
          )
          :
          ''
          "
          style="width: 100%"
        />
    </template>
  </WorkPackageSubPageModule>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { WorkPackageReworkMixin } from '@/mixins/WorkPackageRework.mixin.js'
import { TColor } from '@/mixins/TColor.mixin.js';
import WorkPackageSubPageModule from '@/modules/WorkPackageWIP/WorkPackageSubPageModule.module.vue';
import StepPageStepList from '@/modules/WorkPackageWIP/StepPageStepList.module.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';

  export default {
    components: {
      StepPageStepList,
      WorkPackageSubPageModule,
      TIcon,
    },

    mixins: [
      WorkPackageReworkMixin,
      TColor,
    ],

    props: [
      'location',
      'step_type',
      'backlog',
      'prefix',
    ],

    data: () => ({
    }),

    created() {
      this.loadData();
    },

    watch: {
      workpackage_id() {
        this.loadData();
      },

      step_type() {
        this.loadData();
      }
    },

    computed: {
      ...mapGetters('Ultra', [
        'getUObjects'
      ]),
      ...mapGetters('Project', [
        'hasProjectPermissionForTWP'
      ]),

      steps() {
        return this.getUObjects({type: `${this.histprefix}${this.prefix}${this.step_type.toLowerCase()}steps`, ids: this.workpackage[`${this.histprefix}${this.prefix}${this.step_type.toLowerCase()}steps`]});
      },
      transparent_color() {
        return this.getTranspHexColor(this.workpackage_fg_hex);
      },
    },

    methods: {
      ...mapActions('Ultra', [
        'createUObject',
        'updateUObject',
        'deleteUObject',
        'updateUObjectPosition',
      ]),
      ...mapActions('SnackBar', [
        'requestSnackbarUpdatePosition'
      ]),
      ...mapActions('ProjectWallet', [
        'updateStepCardStatus',
        'increaseUpdateKeyStepCard',
      ]),

      getStepUrl(step_type, step_id) {
        let step_url;
        if (this.backlog) {
          step_url = [
            {projects: this.project_id},
            {[`${this.histprefix}wbgroups`]: this.wbgroup_id},
            {[`${this.histprefix}wblines`]: this.wbline_id},
            {[`${this.histprefix}wbworkpackages`]: this.workpackage_id},
            {[`${this.histprefix}${this.prefix}${step_type.toLowerCase()}steps`]: step_id},
          ]
        } else {
          step_url = [
            {projects: this.project_id},
            {[`${this.histprefix}trains`]: this.train_id},
            {[`${this.histprefix}taktareas`]: this.taktarea_id},
            {[`${this.histprefix}twaggons`]: this.twaggon_id},
            {[`${this.histprefix}tworkpackages`]: this.workpackage_id},
            {[`${this.histprefix}${this.prefix}${step_type.toLowerCase()}steps`]: step_id},
          ]
        }
        if (this.location.includes('HistProjectTaktPlan')) {
          step_url.splice(1, 0, {histprojects: this.$route.params.histproject_id});
        }
        return step_url;
      },

      test() {
        console.log("test ok");
      },

      loadData() {
        this.loading = true;
        this.$store.dispatch('Ultra/requestUObject', {
          url: this.getStepUrl(this.step_type, '').concat([{showWithEntitiesNormalized: ''}]),
          add_u_object: true
        }).then(() => {
          this.loading = false;
        });
      }
    },
  }
</script>

<style>
.header-slot-total {
  font-size: 10pt;
  display: flex;
  grid-gap: 4px;
  align-items: center;
}
</style>
